import { render, staticRenderFns } from "./link-title.vue?vue&type=template&id=ba846fae&scoped=true&"
import script from "./link-title.vue?vue&type=script&lang=js&"
export * from "./link-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba846fae",
  null
  
)

export default component.exports